"use client";

import { Gallery, Item } from "react-photoswipe-gallery";
import Link from "next/link";
import React from "react";
import Image from "next/image";
import Skeleton from "react-loading-skeleton"; // Import the skeleton loader
import "react-loading-skeleton/dist/skeleton.css"; // Import styles for skeleton loader
import DEFAULT_IMG from "@/img/gallery/1/2.png";
import { StarRating } from "../common/StarRating";

export default function GalleryOne({
  hotel,
  loading,
}: {
  hotel: any;
  loading: boolean;
}) {
  const hotelImages = hotel?.hotel_images?.regular;

  // Dynamically prepare the images data
  const extendedData = [
    ...(hotelImages ? hotelImages.slice(0, 5) : []),
    ...Array.from({
      length: hotelImages ? Math.max(5 - hotelImages.length, 0) : 5,
    }).map((_, index) => ({
      id: hotelImages ? hotelImages.length + index + 1 : index + 1,
      url: DEFAULT_IMG,
      isValid: DEFAULT_IMG ? false : true,
      caption: "",
    })),
  ];

  return (
    <>
      {/* <ModalVideo
        channel="youtube"
        // autoPlay={true}
        isOpen={isOpen}
        videoId="oqNZOOWF8qM"
        onClose={() => setOpen(false)}
      /> */}
      <section className="pt-10">
        <div className="container">
          <div className="row y-gap-20 justify-between items-end">
            <div className="col-auto">
              <div className="row x-gap-20  items-center">
                {loading ? (
                  <>
                    <div className="col-auto">
                      <Skeleton count={1} width={200} />
                    </div>

                    <div className="col-auto">
                      <Skeleton count={1} width={100} />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-auto">
                      <h1 className="text-22 lg:text-20 sm:text-20 fw-600">
                        {" "}
                        {hotel?.name}
                      </h1>
                    </div>

                    <div className="col-auto">
                      <StarRating value={hotel?.category} />
                    </div>

                    {hotel?.tripadvisor_data?.num_reviews > 0 && (
                      <>
                    <div className="col-auto">
                      {hotel?.tripadvisor_data && (
                        <div className="lh-15 fw-500">
                           <Link href={`${hotel?.tripadvisor_data?.web_url}`} target="_blank">
                          <Image
                            src={hotel?.tripadvisor_data?.rating_image_url}
                            alt="Rating image"
                            width={100}
                            height={100}
                          />
                          </Link>
                        </div>
                      )}
                    </div>
                    <div className="col-auto">
                      <div className="lh-15 text-light-1">
                      <a href="#reviews"> {hotel?.tripadvisor_data?.num_reviews} reviews</a>
                      </div>
                    </div>
                    </>
                    )}

                  </>
                )}
              </div>

              <div className="row x-gap-20 y-gap-20 items-center">
                <div className="col-xl-12  col-sm-12">
                  {loading ? (
                    <div className="d-flex items-center text-15 text-light-1">
                      <Skeleton count={1} width={100} />{" "}
                      <Skeleton count={1} width={100} />
                    </div>
                  ) : (
                    <div className="d-flex items-center  text-light-1 sm:mt-10 md:mt-10 lg:mt-10">
                      <i className="icon-location-2 text-16 mr-5" />
                      <span className="text-13">{hotel?.address}</span>
                    </div>
                  )}
                </div>
                {/* <div className="col-auto">
                  <button
                    data-x-click="mapFilter"
                    className="text-blue-1 text-15 underline"
                  >
                    Show on map
                  </button>
                </div> */}
              </div>
            </div>

            {hotel?.rates?.length > 0 &&  <div className="col-xl-2 col-md-12 col-sm-12">
              <div className="row x-gap-15 y-gap-15 items-center">
                <div className="col-auto">
                  {loading ? (
                    <>
                      <Skeleton count={1} width={200} />
                      <Skeleton count={1} width={200} />
                    </>
                  ) : (
                    <>
                      <div className="text-14">
                        From{" "}
                        <span className="text-22 text-dark-1 fw-500">
                          {hotel?.rates?.[0]?.currency}{" "}
                          {hotel?.rates?.[0]?.priceWithMarkup}
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div className="col-auto">
                  {loading ? (
                    <>
                      <Skeleton count={1} width={200} height={50} />
                    </>
                  ) : (
                    <>
                      <Link
                        href="#rooms"
                        className="button h-50 px-24 -dark-1 bg-blue-1 text-white"
                      >
                        Select Room{" "}
                        {/* <div className="icon-arrow-top-right ml-15" /> */}
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>

            }
          </div>

          <Gallery withCaption>
            <div className="galleryGrid -type-1 pt-30">
              {loading
                ? // Show skeleton loaders if data is loading
                  Array(5)
                    .fill(0)
                    .map((_, index) => (
                      <div
                        key={index}
                        className={
                          index === 0
                            ? "galleryGrid__item relative d-flex d-sm-none" // Show only on mobile (d-flex on mobile)
                            : index % 2 === 0
                            ? "galleryGrid__items relative d-none d-sm-block" // Hide on mobile and show on desktop for even index
                            : "galleryGrid__items  d-none d-sm-block" // Hide on mobile and show on desktop for odd index
                        }
                        // className={
                        //   index === 0
                        //     ? "galleryGrid__item relative d-flex"
                        //     : index % 2 == 0
                        //     ? "galleryGrid__items relative d-flex"
                        //     : "galleryGrid__items"
                        // }
                      >
                        <Skeleton
                          width={index === 0 ? 655 : 300}
                          height={index === 0 ? 618 : 300}
                          className="borderradius-40"
                        />
                      </div>
                    ))
                : extendedData?.map((image, index) => (
                    <div
                      key={image?.id}
                      className={
                        index === 0
                          ? "galleryGrid__item relative d-flex d-sm-none" // Show only on mobile (d-flex on mobile)
                          : index % 2 === 0
                          ? "galleryGrid__items relative d-none d-sm-block" // Hide on mobile and show on desktop for even index
                          : "galleryGrid__items  d-none d-sm-block" // Hide on mobile and show on desktop for odd index
                      }
                      // className={
                      //   index === 0
                      //     ? "galleryGrid__item relative d-flex"
                      //     : index % 2 == 0
                      //     ? "galleryGrid__items relative d-flex d-sm-block"
                      //     : "galleryGrid__items"
                      // }
                    >
                      <Item
                        original={image?.url}
                        thumbnail={image?.url}
                        // width={index == 0 ? 660 : 300}
                        // height={index == 0 ? 612 : 300}
                        width={1000}
                        height={750}
                        caption={image?.caption || ""}
                        cropped={true}
                      >
                        {({ ref, open }) => (
                          <>
                            <Image
                              src={image?.url}
                              ref={ref}
                              onClick={open}
                              alt={`Gallery image ${index ?? ""}`}
                              className="rounded-4"
                              width={index == 0 ? 660 : 300}
                              height={index == 0 ? 612 : 300}
                              role="button"
                              priority={true}
                            />
                            {/* {index === 0 && (
                              <div className="absolute px-20 py-20 col-12 d-flex justify-end">
                                <button className="button -blue-1 size-40 rounded-full flex-center bg-white text-dark-1">
                                  <i className="icon-heart text-16" />
                                </button>
                              </div>
                            )} */}
                          </>
                        )}
                      </Item>

                      {(index == 4) && (
                        <div className="absolute px-10 py-10 col-12 d-flex justify-center items-center" style={{
                          top: "70%",
                        }}>   
                          <Item
                            original={image?.url}
                            thumbnail={image?.url}
                            // width={450}
                            // height={375}
                            width={1000}
                            height={750}
                          >
                            {({ ref, open }) => (
                              <div
                                className="button -blue-1 px-24 py-15 bg-white text-dark-1 js-gallery"
                                ref={ref}
                                onClick={open}
                                role="button"
                              >
                                See All Photos
                              </div>
                            )}
                          </Item>
                        </div>
                      )}
                    </div>
                  ))}
            </div>
          </Gallery>
        </div>
      </section>
    </>
  );
}
